import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useShowMoreButton } from '../../../hooks/useShowMoreButton';
import useToggle from '../../../hooks/useToggle';

const ReadMore = memo(({ description }) => {
  const { t } = useTranslation();
  const [visibleText, showText] = useToggle(false);
  const [targetRef, showButton] = useShowMoreButton();

  return (
    <>
      <div
        className={classnames('read-more', !visibleText && 'read-more--pruned')}
        ref={targetRef}
        id="read-more"
      >
        {description}
      </div>
      {showButton && !visibleText && (
        <div
          className={'read-more__btn'}
          onClick={showText}
          onKeyPress={() => {}}
          tabIndex={0}
          role="button"
        >
          {t('common.read_more')}
        </div>
      )}
    </>
  );
});

ReadMore.propTypes = {
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

ReadMore.displayName = 'ReadMore';

export default ReadMore;
